import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UlmClientType } from "@custom-types/ulm-types";
import { LanguageCodes } from "@flat-ui";

/** ULM configuration state */
export interface UlmConfigState {
  /** ULM client */
  client: UlmClientType;

  /** Language for the application */
  language: LanguageCodes;
}

const initialState: UlmConfigState = {
  client: "default",
  language: LanguageCodes.English,
};

/**
 * Slice to access the ULM configuration state
 */
const ulmConfigSlice = createSlice({
  name: "ulmConfig",
  initialState,
  reducers: {
    setUlmConfigState(state, action: PayloadAction<UlmConfigState>) {
      state.client = action.payload.client;
      state.language = action.payload.language;
    },
    resetUlmConfigState: () => initialState,
  },
});

export const { setUlmConfigState, resetUlmConfigState } =
  ulmConfigSlice.actions;

export const ulmConfigReducer = ulmConfigSlice.reducer;
